import { LegalPagePathsQuery, LegalPageQuery, LegalPageQueryVariables } from '@/graphql';
import LegalPageQueryDocument from '@/graphql/queries/LegalPage.gql';
import LegalPagePathsQueryDocument from '@/graphql/queries/LegalPagePaths.gql';
import LegalDocumentPage from '@/layouts/pages/legal/DocumentPage';
import LegalHTMLPage from '@/layouts/pages/legal/HTMLPage';
import LegalTextPage from '@/layouts/pages/legal/TextPage';
import CraftClient from '@/lib/graphql';
import { getStaticPagePaths, getStaticPageProps, notFoundResponse } from '@/lib/next';
import LegalTemplate from '@/templates/LegalTemplate';

const LegalPageHandler: PageTemplate<LegalPageQuery> = ({ entry }) => {
  if (!entry) return null;

  switch (entry.__typename) {
    case 'legalPages_textPage_Entry':
      return <LegalTextPage entry={entry} />;
    case 'legalPages_document_Entry':
      return <LegalDocumentPage entry={entry} />;
    case 'legalPages_htmlPage_Entry':
      return <LegalHTMLPage entry={entry} />;
    default:
      return null;
  }
};

LegalPageHandler.template = LegalTemplate;

export default LegalPageHandler;

export const getStaticProps = getStaticPageProps<{}, { slug: string[] }>(
  (params) => `legal/${params?.slug}`,
  async ({ client, uri }) => {
    const { entry } = await client.request<LegalPageQuery, LegalPageQueryVariables>(LegalPageQueryDocument, { uri });

    if (entry) {
      return {
        props: {
          entry,
        },
      };
    }

    /* If all else fails, just 404 */
    return notFoundResponse;
  },
);

export const getStaticPaths = getStaticPagePaths('legal', async (context) => {
  if (process.env.SKIP_BUILD_STATIC_GENERATION) {
    return {
      paths: [],
      fallback: 'blocking',
    }
  }
  const client = new CraftClient();

  const data = await client.request<LegalPagePathsQuery>(LegalPagePathsQueryDocument);

  const paths =
    data.entries?.map((path) => ({
      params: {
        slug: path?.slug!,
      },
    })) || [];

  return {
    paths,
    fallback: 'blocking',
  };
});
